import styled from 'styled-components';
import Icon from '../../assets/images/WarningTriangleIcon.svg';

const ErrorIconXS = styled.span`
  background: url(\"${Icon}\") no-repeat left center;
  background-size: 12px 14px;
  display: block;
  position: relative;
  width: 12px;
  height: 12px;
`;

export default ErrorIconXS;
